// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"592c31a4","703":"6f22903a"}[chunkId] + ".chunk.js";
};